import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const EmployeesActionsToggle = ({ employee, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(employee.active ? 'actions.deactivate' : 'actions.activate')}
    color={employee.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    onClick={(e) => {
      e.preventDefault();
      handleClick(employee.id);
    }}
  />
);

export default translate()(EmployeesActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/list/actions/EmployeesActionsToggle.js